import { gql } from '@apollo/client';

export const GET_BAG_DETAIL_PAGED = gql`
    query GetBagDetailPaged($bagNumber: String!) {
        bagDetail: getBagDetailPaged(bagNumber: $bagNumber) {
            id
            bagNumber
            bagType
            businessType
            fromLocation
            toLocation
            nextStop
            lengthCm
            widthCm
            heightCm
            weightKg
            sortingInfo
            warehouseId
            warehouse {
                id
                name
            }
            bagTaskId
            bagTaskName
            sortingCode
            status
            handoverVehicle
            handoverAt
            carrierCode
            ttBizType
            sortingSegmentCode
            lastMileSortingCode
            sourceType
            sorterCode
            sortingChuteCodes
            createdAt
            completeTime
            externalBusinessType
            bagContainerId
            containerCode
            containerName
            containerTareWeightKg
        }
    }
`;

export interface BagDetailPagedType {
    id: number;
    bagNumber: string;
    bagType: number;
    businessType?: number;
    fromLocation?: string;
    toLocation?: string;
    nextStop?: string;
    lengthCm?: number;
    widthCm?: number;
    heightCm?: number;
    weightKg?: number;
    sortingInfo?: string;
    warehouseId: number;
    warehouse?: {
        id: number;
        name: string;
    };
    bagTaskId?: number;
    bagTaskName?: string;
    sortingCode?: string;
    status: number;
    handoverVehicle?: string;
    handoverAt?: number;
    carrierCode?: number;
    ttBizType?: string;  // TT业务类型：CBT / FBT（bag.tt_biz_type）
    sortingSegmentCode?: string;  // 分拣业务段码（sorting_rule_first_sorting_rule_second，_ 拼接）
    lastMileSortingCode?: string;  // 尾程业务段码（bag.sorting_code）
    sourceType: number;  // 来源类型：0-手动创建，1-组包创建，2-交叉带创建，3-批次创建
    sorterCode?: string;  // 分拣机编码
    sorterType?: number;  // 分拣机类型：1-DWS，2-交叉带
    sortingChuteCodes?: string;  // 落格格口编码
    createdAt: string;
    completeTime?: number;
    /** 外部业务类型：0-普通，1-PPMOD */
    externalBusinessType?: number;
    /** 容器主键（bag_container.id） */
    bagContainerId?: number | null;
    /** 容器码（0-其他/1-LOW/2-HIGH/3-OTR-A/4-OTR-B） */
    containerCode?: number | null;
    /** 容器展示名（含尺寸） */
    containerName?: string | null;
    /** 容器皮重（kg）；展示 Package Weight 时与 weightKg 相加 */
    containerTareWeightKg?: number | null;
}

export interface GetBagDetailPagedResponse {
    bagDetail: BagDetailPagedType | null;
}

export interface PageRequestTypeInput {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
}

// 为了向后兼容，保留 PageRequestType 作为别名
export type PageRequestType = PageRequestTypeInput;
